
export default function IconPricing() {
  return (
    <svg
      height="512"
      viewBox="0 0 58 58"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2155606"
    >
      <g id="004---Money-Off">
        <path
          id="Shape"
          d="m9.92 25.13h12.46c-3.3517423-2.2232943-5.3667504-5.9779093-5.3667504-10s2.0150081-7.77670569 5.3667504-10h-12.46c-.44374873 2.50115012-2.4144478 4.45182176-4.92 4.87v10.21c2.520571.4245846 4.49541544 2.399429 4.92 4.92z"
        ></path>
        <path
          id="Shape"
          d="m19 15.13c0 5.5228475 4.4771525 10 10 10s10-4.4771525 10-10-4.4771525-10-10-10-10 4.4771525-10 10zm10 1c-1.995571-.0239195-3.6681956-1.5151202-3.9200729-3.4948762-.2518774-1.979756.9940652-3.8422757 2.9200729-4.3651238v-1.14c0-.55228475.4477153-1 1-1s1 .44771525 1 1v1.14c1.7614029.45478205 2.9940928 2.040843 3 3.86 0 .5522847-.4477153 1-1 1s-1-.4477153-1-1c0-1.1045695-.8954305-2-2-2s-2 .8954305-2 2 .8954305 2 2 2c2.0098387.0057389 3.7033294 1.5019627 3.9566732 3.4957785s-1.0121382 3.8660208-2.9566732 4.3742215v1.15c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.15c-1.7578185-.4538348-2.9895609-2.0345709-3-3.85 0-.5522847.4477153-1 1-1s1 .4477153 1 1c0 1.1045695.8954305 2 2 2s2-.8954305 2-2-.8954305-2-2-2z"
        ></path>
        <path
          id="Shape"
          d="m2 30.13h54c1.1045695 0 2-.8954305 2-2v-26c0-1.1045695-.8954305-2-2-2h-54c-1.1045695 0-2 .8954305-2 2v26c0 1.1045695.8954305 2 2 2zm1-21c0-.55228475.44771525-1 1-1 2.209139 0 4-1.790861 4-4 0-.55228475.44771525-1 1-1h40c.5522847 0 1 .44771525 1 1 0 2.209139 1.790861 4 4 4 .5522847 0 1 .44771525 1 1v12c0 .5522847-.4477153 1-1 1-2.209139 0-4 1.790861-4 4 0 .5522847-.4477153 1-1 1h-40c-.55228475 0-1-.4477153-1-1 0-2.209139-1.790861-4-4-4-.55228475 0-1-.4477153-1-1z"
        ></path>
        <path
          id="Shape"
          d="m35.62 25.13h12.46c.4245846-2.520571 2.399429-4.4954154 4.92-4.92v-10.21c-2.5175546-.42331376-4.4915649-2.39331192-4.92-4.91h-12.46c3.3691791 2.22022829 5.3970007 5.9850549 5.3970007 10.02s-2.0278216 7.7997717-5.3970007 10.02z"
        ></path>
        <rect
          id="Rectangle-path"
          height="7"
          rx=".5"
          width="10"
          x="8"
          y="34.13"
        ></rect>
        <rect
          id="Rectangle-path"
          height="11"
          rx=".5"
          width="10"
          x="24"
          y="34.13"
        ></rect>
        <path
          id="Shape"
          d="m49.5 34.13h-9c-.2761424 0-.5.2238576-.5.5v14c0 .2761424-.2238576.5-.5.5h-1.39c-.195349.0021901-.3715303.1179544-.4510734.296389s-.0478773.3868536.0810734.533611l6.89 7.75c.0947622.1042571.229112.1636966.37.1636966s.2752378-.0594395.37-.1636966l6.89-7.71c.1289507-.1467574.1606165-.3551764.0810734-.533611s-.2557244-.2941989-.4510734-.296389h-1.39c-.2761424 0-.5-.2238576-.5-.5v-14c.0111879-.1393912-.0365088-.2770979-.1315169-.3797066s-.2286443-.1607417-.3684831-.1602934z"
        ></path>
      </g>
    </svg>
  );
}
